import React from 'react';
import {TextFieldDefinition} from '../../fields-definitions/text-field-definition';
import {NumericFieldDefinition} from '../../fields-definitions/numeric-field-definition';
import {makeConfigurationArea} from '../make-configuration-area';
import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import {BooleanFieldDefinition} from '../../fields-definitions/boolean-field-definition';
import {ROOT_CONFIGURATION_KEYS} from '../../root-configuration-keys';
import {
    ParseValueResponse,
    TextValueEditorComponent
} from '../../../../components/value-editors/text-value-editor/text-value-editor.component';


class ReminderIntervalsField extends TextFieldDefinition {

    constructor() {
        super('Reality Check Interval Reminder', 'Malta & UK | Minutes, Ex: 1,3,5')
    }
    private _prependZeroIfMissing = (value: string) : ParseValueResponse => {
        // we need to do this because the drop down inside CGP that selects the interval reminder
        // assumes that the first item in the drop down is the Off value
        if(value) {
            value = value.trim();
            if(!value.startsWith('0')) {
                return {
                    isValid: true,
                    value: ('0,' + value).replace(',,', ',')
                }
            }
        }
        return {
            isValid: true,
            value: value
        }
    };

    render(): React.ReactNode {
        return (<TextValueEditorComponent key={this.configurationKey} fieldDefinition={this} parseUserInput={this._prependZeroIfMissing} />);
    }
}


export function makeConfigurationOverridesArea(services: ILauncherServiceFactory) {
    return makeConfigurationArea(ROOT_CONFIGURATION_KEYS.sdk, services, {
        IdleRecommendations: {
            // I know 'recommendations' is misspelt, but this is how it is in the old launcher ?
            isIdleRecommendatinonsFeatureOn: new BooleanFieldDefinition('IdleRecommendations Enabled')
        },
        NextGame: {
            initialChance: new NumericFieldDefinition('Next Game Popup InitialChance', 'Example: 50'),
            isFeatureOn: new BooleanFieldDefinition('Next Game Popup Toggle On'),
            maxChance: new TextFieldDefinition('Next Game Popup MaxChance', 'Example: 85'),
            supportOnlyRealMode: new BooleanFieldDefinition('Next Game Popup SupportOnlyRealMode')
        },
        OAuth2: {
            defaultAccessTokenLifeTime: new TextFieldDefinition('Idle Timeout(Hh:mm:ss)')
        },
        Regulation: {
            realityCheckInterval: new TextFieldDefinition('Reality Check Interval(Hh:mm)'),
            reminderIntervals: new ReminderIntervalsField(),
            Spain: {
                MaxDurationsInMinutesForPC: new TextFieldDefinition('ES Time Limit For PC', 'Minutes, Ex: 1,3,5'),
                MaxDurationsInMinutesForMobile: new TextFieldDefinition('ES Time Limit For Mobile', 'Minutes, Ex: 1,3,5'),
                LossLimitPercentages: new TextFieldDefinition('ES Loss Limit', 'Percentage, Ex: 10,50,100'),
                RestrictionPeriodsInMinutes: new TextFieldDefinition('ES Restriction Timer', 'Minutes, Ex: 1,3,5'),
                IntervalReminderInMinutes: new TextFieldDefinition('ES Interval Reminder Timer', 'Minutes, Ex: 1,3,5'),
            }
        },
        Skin: {
            webappNJDownloadAppPageEnabled: new BooleanFieldDefinition('Block Game open on WebApp'),
        }
    });
}